'use strict';

/*
*   Allows users to navigate Tab panels using the arrow keys.
*   This content is licensed according to the W3C Software License at
*   https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
*/
(function () {
    var tablist = $('[role="tablist"]')[0];
    var tabs;
    var panels;

    // For easy reference
    var keys = {
        end: 35,
        home: 36,
        left: 37,
        up: 38,
        right: 39,
        down: 40,
        delete: 46,
        enter: 13,
        space: 32
    };

    // Add or subtract depending on key pressed
    var direction = {
        37: -1,
        38: -1,
        39: 1,
        40: 1
    };

    /**
     * Generates jQuery selector arrays
     */
    function generateArrays() {
        tabs = $('[role="tab"]');
        panels = $('[role="tabpanel"]');
    }

    /**
     * Focus first tab
     */
    function focusFirstTab() {
        tabs[0].focus();
    }

    /**
     * Focus last tab
     */
    function focusLastTab() {
        tabs[tabs.length - 1].focus();
    }

    /**
     * Deactivate all tabs and tab panels
     */
    function deactivateTabs() {
        for (var t = 0; t < tabs.length; t++) {
            tabs[t].setAttribute('tabindex', '-1');
            tabs[t].setAttribute('aria-selected', 'false');
            tabs[t].classList.remove('active-tab-link', 'active');
        }

        for (var p = 0; p < panels.length; p++) {
            panels[p].setAttribute('hidden', 'hidden');
            panels[p].classList.remove('active');
        }
    }

    /**
     * Activates any given tab panel
     * @param {Element} tab - DOM element (native js)
     * @param {boolean} setFocus - if we should set focus on this tab or not
     */
    function activateTab(tab, setFocus) {
        var useFocus = setFocus || true;
        // Deactivate all other tabs
        deactivateTabs();

        // Remove tabindex attribute
        tab.removeAttribute('tabindex');

        // Set the tab as selected
        tab.setAttribute('aria-selected', 'true');
        tab.classList.add('active-tab-link', 'active');

        // Get the value of aria-controls (which is an ID)
        var controls = tab.getAttribute('aria-controls');

        // Remove hidden attribute from tab panel to make it visible
        if (controls) {
            controls.split(' ').forEach(function (control) {
                $('#' + control).removeAttr('hidden').addClass('active');
            });
        }

        // Trigger custom event on tab anchor/link
        $(tab).trigger('shown.adatab');

        // Set focus when required
        if (useFocus) {
            tab.focus();
        }
    }

    /**
     * When a tab is clicked, activateTab is fired to activate it
     * @param {event} event - JS click, keydown, or keyup event
     */
    function clickEventListener(event) {
        var tab = $(event.target).closest('[role="tab"]');
        if (tab.length) {
            activateTab(tab.get(0), false);
        }
    }

    /**
     * Either focus the next, previous, first, or last tab
     * depending on key pressed
     * @param {event} event - JS click, keydown, or keyup event
     */
    function switchTabOnArrowPress(event) {
        var pressed = event.keyCode;

        if (direction[pressed]) {
            var target = event.target;
            if (target.index !== undefined) {
                if (tabs[target.index + direction[pressed]]) {
                    tabs[target.index + direction[pressed]].focus();
                } else if (pressed === keys.left || pressed === keys.up) {
                    focusLastTab();
                } else if (pressed === keys.right || pressed === keys.down) {
                    focusFirstTab();
                }
                activateTab(document.activeElement);
            }
        }
    }

    /**
     * When a tablistâ€™s aria-orientation is set to vertical,
     * only up and down arrow should function.
     * In all other cases only left and right arrow function.
     * @param {event} event - JS click, keydown, or keyup event
     */
    function determineOrientation(event) {
        var key = event.keyCode;
        var vertical = tablist.getAttribute('aria-orientation') === 'vertical';
        var proceed = false;

        if (vertical) {
            if (key === keys.up || key === keys.down) {
                event.preventDefault();
                proceed = true;
            }
        } else if (key === keys.left || key === keys.right) {
            proceed = true;
        }

        if (proceed) {
            switchTabOnArrowPress(event);
        }
    }

    /**
     * Handle keydown on tabs
     * @param {event} event - JS click, keydown, or keyup event
     */
    function keydownEventListener(event) {
        var key = event.keyCode;

        switch (key) {
            case keys.end:
                event.preventDefault();
                // Activate last tab
                focusLastTab();
                activateTab(document.activeElement);
                break;
            case keys.home:
                event.preventDefault();
                // Activate first tab
                focusFirstTab();
                activateTab(document.activeElement);
                break;
            // Up and down are in keydown
            // because we need to prevent page scroll >:)
            case keys.up:
            case keys.down:
                determineOrientation(event);
                break;
            default:
                break;
        }
    }

    /**
     * Handle keyup on tabs
     * @param {event} event - JS click, keydown, or keyup event
     */
    function keyupEventListener(event) {
        var key = event.keyCode;

        switch (key) {
            case keys.left:
            case keys.right:
                switchTabOnArrowPress(event);
                break;
            default:
                break;
        }
    }

    /**
     * Add event listeners
     * @param {number} index - index of tab in tabs array
     */
    function addListeners(index) {
        tabs[index].addEventListener('click', clickEventListener);
        tabs[index].addEventListener('keydown', keydownEventListener);
        tabs[index].addEventListener('keyup', keyupEventListener);

        // Build an array with all tabs (<button>s) in it
        tabs[index].index = index;
    }

    generateArrays();

    // Bind listeners
    for (var i = 0; i < tabs.length; ++i) {
        addListeners(i);
    }
}());
